import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconMoveDownStyle0 = gravityIconIndividualCss;

const GravityIconMoveDown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '7a62e07323a511377934b3a203e3831c97ecad6d', color: this.color, size: this.size }, h("svg", { key: '1a5577084d72a7f6cdd41f6dae3509e2017d0b9b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c0877ff92662317147a7ea6644f822840735dd73', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.21 13.79 5.28-5.28a.3.3 0 0 0-.21-.51H5.72a.3.3 0 0 0-.21.51l5.28 5.28a.29.29 0 0 0 .42 0Z", fill: "currentColor" }))));
    }
};
GravityIconMoveDown.style = GravityIconMoveDownStyle0;

export { GravityIconMoveDown as gravity_icon_move_down };

//# sourceMappingURL=gravity-icon-move-down.entry.js.map